import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AddressManagementService, { AddressReportResponse } from '../../services/addressManagementService';
import AddressReportManagement from './AddressReportManagement';

const ReportPageManagement: React.FC = () => {
    const { traceId } = useParams<{ traceId: string }>();
    const [reportData, setReportData] = useState<AddressReportResponse | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!traceId) {
            setError('Invalid or missing traceId in URL.');
            return;
        }

        const fetchReport = async () => {
            setIsLoading(true);
            setError(null);
            try {
                console.log(`Fetching Address Report (Management) for traceId: ${traceId}`);
                const data = await AddressManagementService.getAddressReport(traceId);
                setReportData(data);
            } catch (err: any) {
                const errorMessage = err?.response?.data?.message || err.message || "Failed to load address report";
                setError(errorMessage);
                console.error(`Failed to fetch Address Report for traceId ${traceId}:`, err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchReport();
    }, [traceId]);

    if (error && !isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f8f9fa', padding: '2rem' }}>
                <div style={{ maxWidth: '600px', width: '100%' }}>
                    <div className="alert alert-danger" role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        <strong>Error Loading Report:</strong> {error}
                    </div>
                </div>
            </div>
        );
    }

    return <AddressReportManagement data={reportData} isLoading={isLoading} />;
};

export default ReportPageManagement;
